import produce from "immer";
import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_FAILURE,
  FETCH_SETTINGS_SUCCESS,
  //
  SAVE_SETTINGS,
  SAVE_SETTINGS_FAILURE,
  SAVE_SETTINGS_SUCCESS,
} from "./constants";

export const initialState = {
  isFetchingSettings: false,
  isSubmitting: false,
  currentSettings: {},
};

const SettingsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_SETTINGS:
        draft.isFetchingSettings = true;
        draft.currentSettings = {};
        break;
      case FETCH_SETTINGS_SUCCESS:
        draft.isFetchingSettings = false;
        draft.currentSettings = action.payload;
        break;
      case FETCH_SETTINGS_FAILURE:
        draft.isFetchingSettings = false;
        draft.currentSettings = {};
        break;
      // Add
      case SAVE_SETTINGS:
        draft.isSubmitting = true;
        break;
      case SAVE_SETTINGS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case SAVE_SETTINGS_FAILURE:
        draft.isSubmitting = false;
        break;

      default:
        return state;
    }
  });

export default SettingsReducer;
